/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ICatalogPickerViewProps } from './catalog-picker';

/**
 * ICatalogPickerViewProps.
 * @param props - ICatalogPickerViewProps.
 * @returns - Render Catalog Picker.
 */
export const CatalogPickerViewFunctionComponent: React.FC<ICatalogPickerViewProps> = props => {
    const { catalogPicker } = props;
    return (
        <Module {...catalogPicker}>
            {props.heading}
            {props.paragraph}
            {props.catalogs}
        </Module>
    );
};

export default CatalogPickerViewFunctionComponent;
